module.exports = __webpack_public_path__ + "798bee49aa49fbe4eb65c94a5cc5e286.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C0000166G.png
// module id = 1481
// module chunks = 0